const getMonthName = (date = new Date) =>
  [
    'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
    'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
  ][date.getMonth()];

export const typ_dog = {
  number_of_dogovor: '',
  day_of_dogovor: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  // day_request_of_app_1: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  // day_of_app_2: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  // day_of_app_3: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  day_of_main_add_app: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  day_of_add_app: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  month_of_dogovor: getMonthName(),
  // month_request_of_app_1: getMonthName(),
  // month_of_app_2: getMonthName(),
  // month_of_app_3: getMonthName(),
  month_of_main_add_app: getMonthName(),
  month_of_add_app: getMonthName(),
  year_of_dogovor: (new Date()).getFullYear(),
  year_of_add_app: (new Date()).getFullYear(),
  full_pravovaya_form: '',
  short_pravovaya_form: '',
  full_org_name: '',
  in_face_of_org: '',
  in_face_imen_padej_of_org: '',
  fio_of_face_of_org: '',
  fio_of_face_short_of_org: '',
  is_ustav: '',
  ur_adress: '',
  post_adress: '',
  post_adress_for_korresp: '',
  post_adress_for_main_post: '',
  inn_of_org: '',
  kpp_of_org: '',
  ogrn_of_org: '',
  ras_chet_of_org: '',
  bank_of_org: '',
  koresp_chet_of_org: '',
  bik_of_org: '',
  tel_of_org: '',
  tel_of_buhgalter: '',
  arrived_adress_ground: '',
  arrived_adress_ground_cost: '',
  arrived_adress_avia: '',
  arrived_adress_avia_cost: '',
  email_of_buhgalter: '',
}

export const typ_dog_teo_exp = {
  number_of_dogovor: '',
  day_of_dogovor: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  day_request_of_app_1: ((new Date()).getDate() + 1).toString().padStart(2, '0'),
  month_of_dogovor: getMonthName(),
  month_request_of_app_1: getMonthName(),
  year_of_dogovor: (new Date()).getFullYear(),
  year_request_of_app_1: (new Date()).getFullYear(),
  number_request_of_app_1: '',
  route_of_app_1: '',
  full_pravovaya_form: '',
  short_pravovaya_form: '',
  full_org_name: '',
  in_face_of_org: '',
  in_face_imen_padej_of_org: '',
  fio_of_face_of_org: '',
  fio_of_face_short_of_org: '',
  is_ustav: '',
  ur_adress: '',
  post_adress: '',
  inn_of_org: '',
  kpp_of_org: '',
  ogrn_of_org: '',
  ras_chet_of_org: '',
  bank_of_org: '',
  koresp_chet_of_org: '',
  bik_of_org: '',
  tel_of_org: '',
}